import { valueOrDash } from '../../helpers/utils'

export const QUOTE_FILTER_KEYS = {
  client: 'CÓDIGO DE CLIENTE',
  salesman: 'CREADO POR'
}

export const QUOTE_STATUS_UI_MAP = {
  sent: { label: 'ENVIADO', className: 'sent-style' }
}

export const QUOTE_SHOW_TABS = [
  {
    value: 'quote',
    label: 'Detalles',
    icon: 'info',
    iconSize: 20,
    filled: false
  }
]

export const QUOTE_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_uid'
    },
    {
      icon: 'account_box',
      label: 'Vendedor:',
      valueKey: 'user_full_name',
      filled: true
    },
    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'date_of_order',
      format: 'date'
    }
  ]
}

export const parseCustomFields = (value) => {
  if (Array.isArray(value)) return value
  if (typeof value !== 'string' || value.trim() === '' || value === '[]') return []

  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch (_error) {
    return []
  }
}

export const buildQuoteSummaryFields = (quote) => [
  { label: 'Número de cotización', value: valueOrDash(quote?.uid) },
  { label: 'Para', value: valueOrDash(quote?.name) },
  { label: 'Correo electrónico', value: valueOrDash(quote?.email) },
  { label: 'CC', value: valueOrDash(quote?.email_cc) },
  { label: 'Comentarios', value: valueOrDash(quote?.comments), fullWidth: true }
]

export const buildQuoteCustomFields = (quote) =>
  parseCustomFields(quote?.custom_fields).map((field) => ({
    label: field?.label || field?.code || '-',
    value: valueOrDash(field?.value)
  }))
